import useSWR from 'swr';
import { buildTreeCategories } from '../helpers';
import { useServices } from 'contexts';
import { MenuItem, DiscoveryService } from '@teko/discovery';
import { logger } from '@teko/log';

export interface MenuItemResult {
  parents: MenuItem[];
  menuItems: MenuItem[];
}

export interface MenuItemsResponse {
  result: MenuItemResult;
  isLoading: boolean;
  isError: boolean;
}
interface MenuItemByIdResponse {
  result?: MenuItem;
  isLoading: boolean;
  isError: boolean;
}

// TODO: temporary function, to avoid having to copy it
// will clean it up later.
// ideally move inside discovery method .getMenuItems
export const getMenuItems = async (
  discoveryService: DiscoveryService,
  zone: string,
): Promise<MenuItemResult> => {
  try {
    const data = await discoveryService.getMenuItems(zone);

    return {
      menuItems: data?.result?.menuItems || [],
      parents: buildTreeCategories(data?.result?.menuItems || []),
    };
  } catch (er) {
    logger.error(er);
    return {
      menuItems: [],
      parents: [],
    };
  }
};

export const useMenuItems = (
  zone: string,
  defaultValue: MenuItemResult = { menuItems: [], parents: [] },
): MenuItemsResponse => {
  const { discoveryService } = useServices();

  const { data, error, isValidating } = useSWR(
    [`/menu-items`, zone],
    async (_, zone) => await getMenuItems(discoveryService, zone),
    {
      fallbackData: {
        ...defaultValue,
      },
      onError: (e) => {
        logger.error('getMenuItems error:', e);
        return defaultValue;
      },
    },
  );

  return {
    result: data || {
      menuItems: [],
      parents: [],
    },
    isLoading: !zone ? false : (!error && !data) || isValidating,
    isError: error,
  };
};

export const useMenuItemById = (
  categoryId: number | string,
): MenuItemByIdResponse => {
  const { discoveryService } = useServices();
  const url = `/menu-item/${categoryId}`;

  const { data, error } = useSWR(categoryId ? url : null, async () => {
    return await discoveryService.getMenuItemById(categoryId);
  });
  return {
    result: data?.result,
    isLoading: !categoryId ? false : !error && !data,
    isError: error,
  };
};
